import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ClientFeedbackSummary {
  candidates_shared?: number;
  total_feedback?: number; // legacy
  pending_feedback: number;
  accepted_feedback: number;
  rejected_feedback: number;
}

export interface ClientFeedbackClient {
  id: string;
  email: string;
  full_name: string | null;
}

export interface ClientFeedbackItem {
  id: string;
  client: ClientFeedbackClient;
  candidate_name?: string;
  feedback: string;
  job_application_id: string;
  seen: boolean;
  client_feedback_status: string;
  time_ago: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
  is_deleted: boolean;
}

export interface JobApplicationInfo {
  id: string;
  candidate_name: string;
  user_id: string;
  user_email: string;
}

/** Grouped by candidate (job_application); under each, list of client feedbacks */
export interface ClientFeedbackGroup {
  job_application: JobApplicationInfo;
  feedbacks: ClientFeedbackItem[];
}

export interface ClientFeedbackState {
  summary: ClientFeedbackSummary | null;
  feedback: ClientFeedbackGroup[];
  loading: boolean;
  error: string | null;
}

const initialState: ClientFeedbackState = {
  summary: null,
  feedback: [],
  loading: false,
  error: null,
};

const clientFeedbackSlice = createSlice({
  name: "clientFeedback",
  initialState,
  reducers: {
    setClientFeedbackLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
      if (action.payload) state.error = null;
    },
    setClientFeedbackError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setClientFeedbackData: (
      state,
      action: PayloadAction<{
        summary: ClientFeedbackSummary;
        feedback: ClientFeedbackGroup[];
      }>
    ) => {
      state.summary = action.payload.summary;
      state.feedback = action.payload.feedback;
      state.loading = false;
      state.error = null;
    },
    clearClientFeedback: (state) => {
      state.summary = null;
      state.feedback = [];
      state.error = null;
    },
  },
});

export const {
  setClientFeedbackLoading,
  setClientFeedbackError,
  setClientFeedbackData,
  clearClientFeedback,
} = clientFeedbackSlice.actions;
export default clientFeedbackSlice.reducer;
